import React, { forwardRef, useState } from 'react'
import { WidgetInputMoneyProps } from '../../widget-inputs'
import styles from '../../widget-inputs.module.scss'
import { WidgetInputWrapper } from '../widget-input-wrapper/widget-input-wrapper'

export const WidgetInputMoney = forwardRef<
  HTMLInputElement,
  WidgetInputMoneyProps
>((props, ref) => {
  const {
    label,
    name,
    placeholder,
    error,
    disabled,
    required,
    autoComplete = 'off',
    onChange,
    inputStyles,
    labelStyles,
    currency,
  } = props
  const errorClass = error
    ? styles['form__field__error']
    : styles['form__field']

  const requireClass = required
    ? `${styles['form__label']} ${styles['form__label--required']}`
    : styles['form__label']

  const placeholderText = placeholder || label
  const [helpText, setHelpText] = useState(placeholderText)
  const handleOnBlur = (event: any) => {
    if (event.target.value.length !== 0) {
      setHelpText(label)
    } else {
      setHelpText(placeholderText)
    }
  }

  return (
    <WidgetInputWrapper>
      <div
        // aria-label="show/hide money"
        className={styles['form__currency']}
        // tabIndex={-1}
        // disabled={disabled}
        // type="button"
        // onClick={onHandleShowMoney}
        data-testid="change-input-type"
      >
        {/* <WidgetIcon
          name={`${showMoney ? 'visibilityOff' : 'visibility'}`}
          color={iconColor}
        /> */}
        <span style={labelStyles}>{currency}</span>
      </div>
      <input
        type={'number'}
        id={name}
        inputMode="numeric"
        className={errorClass}
        placeholder={placeholderText}
        onChange={onChange}
        disabled={disabled}
        autoComplete={autoComplete}
        ref={ref}
        onFocus={() => setHelpText(label)}
        onBlur={handleOnBlur}
        style={inputStyles}
      />
      <label htmlFor={name} className={requireClass} style={labelStyles}>
        {helpText}
      </label>
      {error && (
        <span
          className={`${styles['form__message']} ${styles['form__message--visible']} ${styles['form__message--error']}`}
        >
          {error}
        </span>
      )}
    </WidgetInputWrapper>
  )
})

WidgetInputMoney.displayName = 'WidgetInputMoney'
